import { useDispatch, useSelector } from 'react-redux';
import { accountsSlice } from 'app/store';
import { ConfigValuesDisplayMode, ConfigValuesManager } from '../ClientConfigManagementTab/ConfigValuesManager';
import { AssetSelect } from '../ClientConfigManagementTab/AssetSelect';
import { selectConfigValuesSelectedClientId, setSelectedClientId } from 'features/configValues/configValuesSlice';
import { Button } from '@mui/material';
import { setIsDirty } from 'features/common/formSlice';

const { selectActiveUser } = accountsSlice;

const ConfigManagementTab = () => {
    //Look into using useEffect to dispatch to the item service to get the config values
    const activeUser = useSelector(selectActiveUser);
    const selectedClientId = useSelector(selectConfigValuesSelectedClientId);
    const dispatch = useDispatch();

    if (selectedClientId !== activeUser.client_id) {
        dispatch(setSelectedClientId(activeUser.client_id));
    }

    return (
        <>
            <div style={{ marginBottom: '20px' }}>
                <AssetSelect />
            </div>
            <Button
                variant="contained"
                style={{ marginTop: '10px', marginBottom: '10px' }}
                onClick={() => {
                    dispatch(setIsDirty(true));
                }}
            >
                Edit
            </Button>
            <div>
                <ConfigValuesManager configValuesDisplayMode={ConfigValuesDisplayMode.Settings} clientMode={true} />
            </div>
        </>
    );
};

export { ConfigManagementTab };
